export const SUPABASE_TIMEOUT = 60000;
export const POPULATION_MAINTENANCE_INTERVAL = SUPABASE_TIMEOUT-10000;
export const POPULATION_CHECK_INTERVAL = 3000;